/* eslint-disable max-classes-per-file */

import { RequestListProductTypeEnums } from "@/types/product/account/history";
import { imageFallback } from "@/utils/error/imageError";

import { ResponsePresenter } from "../../common/commonClassPresenter";
import {
  ContactDatePresenter,
  DayPlanDataPresenter,
  ListStepDataPresenter,
  RePaymentPresenter,
} from "./historyBookingCommonInterface";

class HotelInfoPresenter {
  id: string;

  name: string;

  nameEn: string;

  slug: string;

  cover: string;

  constructor(response: any) {
    this.id = response?.id || "";
    this.name = response?.name || "";
    this.slug = response?.slug || "";
    this.cover = response?.cover || imageFallback;
    this.nameEn = response?.nameEn || "";
  }
}

export class HotelRoomCriteriaPresenter {
  roomBoardName: string;

  roomName: string;

  checkInOri: string;

  checkOutOri: string;

  checkIn: string;

  checkOut: string;

  numberOfRoom: number;

  adult: number;

  child: number;

  rentalDays: number;

  customerRequest: string;

  constructor(response: any) {
    this.roomBoardName = response?.roomBoardName || "";
    this.roomName = response?.roomName || "";
    this.checkInOri = response?.checkInOri || "";
    this.checkOutOri = response?.checkOutOri || "";
    this.checkIn = response?.checkIn || "";
    this.checkOut = response?.checkOut || "";
    this.numberOfRoom = response?.numberOfRoom || 0;
    this.adult = response?.adult || 0;
    this.child = response?.child || 0;
    this.rentalDays = response?.rentalDays || 0;
    this.customerRequest = response?.customerRequest || "";
  }
}

export class HotelRoomAmenityPresenter {
  id: number;

  nameTh: string;

  nameEn: string;

  groupId: number;

  groupName: string;

  isFree: boolean;

  isOnRequest: boolean;

  image: string;

  constructor(req: any) {
    this.id = req?.id || 0;
    this.nameTh = req?.name || "";
    this.nameEn = req?.nameEn || "";
    this.groupId = req?.groupId || 0;
    this.groupName = req?.groupName || "";
    this.isFree = req?.isFree || false;
    this.isOnRequest = req?.isOnRequest || false;
    this.image = req?.image || imageFallback;
  }
}

export class HotelRoomInfoPresenter {
  roomTypeId: number;

  roomPhoto: string[];

  roomSize: number;

  maxAdults: number;

  minAdults: number;

  maxChildren: number;

  minChildren: number;

  smokingRoom: boolean;

  roomAmenity?: Array<HotelRoomAmenityPresenter>;

  constructor(response: any) {
    this.roomTypeId = response?.roomTypeId || 0;
    this.roomPhoto = response?.roomPhoto || [];
    this.roomSize = response?.roomSize || 0;
    this.maxAdults = response?.maxAdults || 0;
    this.minAdults = response?.minAdults || 0;
    this.maxChildren = response?.maxChildren || 0;
    this.minChildren = response?.minChildren || 0;
    this.smokingRoom = response?.smokingRoom || false;
    this.roomAmenity = (response?.roomAmenity || []).map(
      (amenity: HotelRoomAmenityPresenter) =>
        new HotelRoomAmenityPresenter(amenity),
    );
  }
}

export class HotelLocationPresenter {
  countrySlug: string;

  countryName: string;

  citySlug: string;

  cityName: string;

  areaSlug: string;

  areaName: string;

  latitude: number;

  longitude: number;

  constructor(response: any) {
    this.countrySlug = response?.countrySlug || "";
    this.countryName = response?.countryName || "";
    this.citySlug = response?.citySlug || "";
    this.cityName = response?.cityName || "";
    this.areaSlug = response?.areaSlug || "";
    this.areaName = response?.areaName || 0;
    this.latitude = response?.latitude || 0;
    this.longitude = response?.longitude || 0;
  }
}

export class HotelListDataPresenter {
  type: string;

  rsvnId: number;

  rsvnStatusId: number;

  paymentStatusId: number;

  bookingInternalNo: string;

  pinCode: string;

  isPayLater: boolean;

  paymentStatus: string;

  bookingStatus: string;

  price: number;

  currency: string;

  bookStepIsCancel: boolean;

  reservationNo: number;

  bookingDateOri: string;

  bookingDate: string;

  isPayAtHotel: boolean;

  isManualBooking: boolean;

  isFavourite: boolean;

  // refundStatus: any

  contact: ContactDatePresenter;

  payment: RePaymentPresenter;

  location: HotelLocationPresenter;

  roomCriteria: HotelRoomCriteriaPresenter;

  hotelInfo: HotelInfoPresenter;

  paylaterDeadlineDate: string;

  paylaterDeadlineDateLang: string;

  paylaterChargedDate: string;

  isConjobsFail: boolean;

  dayPlan: DayPlanDataPresenter;

  dateCancelOri: string;

  productType: string;

  dateCancel: string;

  constructor(response: any) {
    this.type = response?.type || "";
    this.rsvnId = response?.rsvnId || 0;
    this.rsvnStatusId = response?.rsvnStatusId || 0;
    this.paymentStatusId = response?.paymentStatusId || 0;
    this.bookingInternalNo = response?.bookingInternalNo || "";
    this.pinCode = response?.pinCode || "";
    this.isPayLater = response?.isPayLater || false;
    this.paymentStatus = (response?.paymentStatus || "").toLocaleLowerCase();
    this.bookingStatus = (response?.bookingStatus || "").toLocaleLowerCase();
    this.price = response?.price || 0;
    this.currency = response?.currency || "";
    this.bookStepIsCancel = response?.bookStepIsCancel || false;
    this.reservationNo = response?.reservationNo || 0;
    this.bookingDateOri = response?.bookingDateOri || "";
    this.bookingDate = response?.bookingDate || "";
    this.isPayAtHotel = response?.isPayAtHotel || false;
    this.isManualBooking = response?.isManualBooking || false;
    this.isFavourite = response?.isFavourite || false;
    this.contact = new ContactDatePresenter(response?.contact);
    this.payment = new RePaymentPresenter(response?.payment);
    this.location = new HotelLocationPresenter(response?.location);
    this.roomCriteria = new HotelRoomCriteriaPresenter(response?.roomCriteria);
    this.hotelInfo = new HotelInfoPresenter(response?.hotelInfo);
    this.paylaterDeadlineDate = response?.paylaterDeadlineDate || "";
    this.paylaterDeadlineDateLang = response?.paylaterDeadlineDateLang || "";
    this.paylaterChargedDate = response?.paylaterChargedDate || "";
    this.isConjobsFail = response?.isConjobsFail || false;
    this.dayPlan = new DayPlanDataPresenter(response?.dayPlan);
    this.dateCancelOri = response?.dateCancelOri || "";
    this.productType = RequestListProductTypeEnums.HOTEL;
    this.dateCancel = response?.dateCancel || "";
  }
}

export class HotelListStepData extends ListStepDataPresenter<
  HotelListDataPresenter[]
> {
  constructor(response: any) {
    super(response, (data) =>
      (data || []).map((val: any) => new HotelListDataPresenter(val)),
    );
  }
}
export class ResponseGetHistoryHotelListPresenter extends ResponsePresenter<
  HotelListStepData[]
> {
  constructor(response: any) {
    super(response, (data) =>
      (data || []).map((val: any) => new HotelListStepData(val)),
    );
  }
}
